import React, { Fragment, useState } from "react";
import { BhiDialog } from "src/UIKit";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import ImportAppointments from "./importAppointments";

type DownloadCsvModalType = {
  show: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  refreshAppointments: () => void;
};

export default function DownloadCsvModal({
  show,
  setShowModal,
  refreshAppointments,
}: DownloadCsvModalType) {
  const [error, setError] = useState<boolean>(false);

  const handleClose = () => {
    setShowModal(false);
    refreshAppointments();
  };

  return (
    <Fragment>
      <BhiDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={show}
        fullWidth={true}
        keepMounted={false}
        title="Import Calendar Events"
      >
        <DialogContent>
          <Stack alignItems="center">
              <ImportAppointments
                refreshAppointments={refreshAppointments}
                handleClose={handleClose}
                error={error}
                setError={setError}
              />
          </Stack>
        </DialogContent>
      </BhiDialog>
    </Fragment>
  );
}
